import { DiContainer } from '@/modules/di/di-container';
import { OffersService } from '../services/offers.service';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { OfferInstance } from '../ts';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import { useStore } from 'effector-react';

const offersService = DiContainer.get(OffersService);

export const $offerToEdit = createStore<OfferDetails | null>(null);

export const setOfferToEdit = createEvent<OfferDetails | null>();

$offerToEdit.on(setOfferToEdit, (_, data) => {
  return data;
});

// GET ALL BUYER OFFERS LIST
export const setOffers = createEvent<any>();
const setOffersLoadingStatus = createEvent<{ loading: boolean; error: boolean }>();

export const $offersDataStatus = createStore({
  loading: false,
  error: false,
}).on(setOffersLoadingStatus, (state, payload) => {
  return payload;
});

export const clearOffersData = createEvent();
export const $offersData = createStore<OfferInstance[] | null>(null)
  .on(setOffers, (_, newData) => {
    return newData;
  })
  .on(clearOffersData, () => {
    return null;
  });

export const fetchBuyerOffersListFx = createEffect(
  async (args: { id: number; md5?: string; disableLoadingStatus?: boolean }) => {
    try {
      !args.disableLoadingStatus &&
        setOffersLoadingStatus({ loading: true, error: false });
      let data = !args.md5
        ? await offersService.getOffersByBuyerId(args.id)
        : await offersService.getOffersByBuyerMd5(args.md5);
      !args.disableLoadingStatus &&
        setOffersLoadingStatus({ loading: false, error: false });
      return data;
    } catch (err) {
      setOffersLoadingStatus({ loading: false, error: true });
      return { error: err };
    }
  },
);

sample({
  clock: fetchBuyerOffersListFx.doneData,
  target: setOffers,
});

// CREATE NEW OFFER
export const createOfferFx = createEffect(
  async (dto: Omit<OfferInstance, 'class' | 'created_at' | 'updated_at'>) => {
    try {
      let data = await offersService.createNewOffer(dto);
      return data;
    } catch (err) {
      return { error: err };
    }
  },
);

// DELETE OFFER
export const deleteOfferFx = createEffect(async (id: number) => {
  try {
    let data = await offersService.deleteOfferById(id);
    return data;
  } catch (err) {
    return { error: err };
  }
});

// EDIT OFFER
export const updateOfferFx = createEffect(
  async ({
    id,
    dto,
    type,
  }: {
    id: number;
    dto: Omit<OfferInstance, 'created_at' | 'class'>;
    type: 'internal' | 'external';
  }) => {
    try {
      if (type === 'external') {
        let data = await offersService.updateExternalOfferById(id, dto);
        return data;
      }
      let data = await offersService.updateOfferById(id, dto);
      return data;
    } catch (err: any) {
      if (err.status) {
        const error = await err.json();
        return error;
      }
      return { error: err };
    }
  },
);

// SWITCH ALL OFFERS
export const switchBuyerOffers = createEffect(
  async ({
    id,
    type,
    enabled,
  }: {
    id: number;
    type: 'internal' | 'external';
    enabled: boolean;
  }) => {
    try {
      const res = await offersService.switchBuyerOffers({
        id,
        is_internal: type === 'internal',
        enabled,
      });
      return res;
    } catch (err: any) {
      const error = await err.json();
      return error;
    }
  },
);
